import { useState } from "react";
import { Tag, Truck, Copy, Check } from "lucide-react";
import { useOffers, FALLBACK_FREE_SHIPPING_AT } from "@/lib/shop";

function offerText(o) {
  if (o.label) return o.label;
  const v = o.type === "percent" ? `${o.value}% off` : `₹${o.value} off`;
  return o.min_order ? `${v} on orders above ₹${o.min_order}` : v;
}

/** Live offers from /api/offers, for the product page and basket. */
export default function Offers({ compact = false, onApply }) {
  const data = useOffers();
  const [copied, setCopied] = useState("");
  const freeAt = data?.free_shipping_at ?? FALLBACK_FREE_SHIPPING_AT;
  const offers = data?.offers || [];
  const copy = async (code) => {
    if (onApply) return onApply(code);
    try { await navigator.clipboard.writeText(code); setCopied(code); setTimeout(() => setCopied(""), 1500); } catch { /* clipboard blocked */ }
  };
  return (
    <div className={compact ? "space-y-2" : "rounded-2xl border border-black/10 bg-white p-5 space-y-3"} data-testid="offers">
      {!compact && <p className="font-body text-[14px] font-semibold text-brand-ink">Offers</p>}
      {!compact && <p className="flex items-start gap-2 font-body text-[14px] text-brand-ink">
        <Truck className="w-4 h-4 mt-0.5 text-brand-gold shrink-0" /> Free delivery across India on orders of ₹{freeAt} or more
      </p>}
      {offers.map((o) => (
        <div key={o.code} className="flex items-start justify-between gap-3">
          <p className="flex items-start gap-2 font-body text-[14px] text-brand-ink">
            <Tag className="w-4 h-4 mt-0.5 text-brand-gold shrink-0" /> {offerText(o)}
          </p>
          <button type="button" onClick={() => copy(o.code)} className="shrink-0 inline-flex items-center gap-1 rounded-control border border-dashed border-brand-gold px-3 py-1 font-mono text-[12px] text-brand-gold-deep hover:bg-brand-gold/10" data-testid={`offer-${o.code}`}>
            {copied === o.code ? <Check className="w-3 h-3" /> : onApply ? null : <Copy className="w-3 h-3" />}
            {onApply ? `Apply ${o.code}` : o.code}
          </button>
        </div>
      ))}
    </div>
  );
}
